export const SCHEME_TYPE = {
    DETAIL: 'detail'
};

export const PLATFORM_TYPE = {
    NIUNIU: 'niuniu',
    MOOMOO: 'moomoo'
};

export const PROTOCOL_TYPE = {
    NN: 'ftnn',
    MOOMOO: 'ftmm'
};

const fnMap = {
    [SCHEME_TYPE.DETAIL]: ({ protocol, stock }) => `${protocol}://quote/stockDetail/${stock.stockId}/1`
};

export const getSchemeLink = (type, stock, platform) => {
    const protocol = platform === PLATFORM_TYPE.NIUNIU ? PROTOCOL_TYPE.NN : PROTOCOL_TYPE.MOOMOO;
    return fnMap[type]?.({ protocol, stock }) || '';
};
